﻿'use strict';

import ko from 'knockout';
import Modal from '@/shared/Modal';

export class AlertViewModel {
    public errorMessage: KnockoutObservable<string>;
    public closeAlertCallback: any;

    constructor() {
        this.errorMessage = ko.observable('');
    }

    public openAlert(error: string): void {
        this.errorMessage(error);
        Modal.show('alert-modal');
    }

    public closeAlert(): void {
        try {
            Modal.close('alert-modal');
        } catch (e) {
            // Ignore
        }
        if (this.closeAlertCallback != null) {
            this.closeAlertCallback();
        }
    }
}

export class CustomAlertViewModel {
    public modalTitle: KnockoutObservable<string>;
    public modalMessage: KnockoutObservable<string>;

    constructor() {
        this.modalTitle = ko.observable('');
        this.modalMessage = ko.observable('');
    }

    public openAlert(title: string, message: string): void {
        if (!title) {
            throw new Error('Modal title must be set');
        }

        this.modalTitle(title);
        this.modalMessage(message);
        Modal.show('custom-alert-modal');
    }

    public closeModal(): void {
        try {
            Modal.close('custom-alert-modal');
        } catch (e) {
            // Ignore
        }
    }
}
